<div class="auth-wrapper auth-v2">
  <app-language-selector></app-language-selector>
    <div class="auth-inner max-width row m-0">
        <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
        <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28"/>
        <h2 class="brand-text text-primary ml-1">MyBenefits</h2></a
    >
        <!-- /Brand logo-->
        <!-- Left Text-->
        <div class="d-flex align-items-center p-5 l-side">
            <div class="w-100 d-lg-flex align-items-center justify-content-center px-3">
                <img
                        class="img-fluid"
                        [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/register-v1-dark.svg'
              : 'assets/images/register-1.svg'
          "
                        alt="Register v1"
                />
            </div>
        </div>
        <!-- /Left Text-->
        <!-- Register-->
        <div class="d-flex align-items-center auth-bg r-side">
            <div class="mx-auto login-form">
                <!-- <div class="company-logo">
                    <img src="assets/images/fitbit-logo.svg" alt="">
                </div> -->
                <h2 class="card-title mb-1">
                    {{ 'CUSTOM_REGISTER.TITLE' | translate }}
                </h2>
                <p class="card-text mb-2">{{ 'CUSTOM_REGISTER.SUBTITLE' | translate }}</p>
                <form
                        *ngIf="customFieldsForm"
                        class="auth-register-form mt-2"
                        [formGroup]="customFieldsForm"
                        (ngSubmit)="onSubmit()"
                >

                    <div class="form-group" *ngFor="let customField of customFields">
                        <label class="form-label">{{ customField.label }}</label>
                        <div class="input-group input-group-merge form-password-toggle"
                             *ngIf="customField.fieldType === 'input'"
                        >
                            <input
                                    type="text"
                                    [formControlName]="customField.id"
                                    class="form-control form-control-merge"
                                    [ngClass]="{ 'is-invalid error': f[customField.id]?.errors && (f[customField.id]?.dirty || f[customField.id]?.touched) }"
                            />
                        </div>
                        <div class="input-group input-group-merge form-password-toggle"
                             *ngIf="customField.fieldType === 'select'">
                            <ng-select
                                [searchable]="false"
                                [appendTo]="'body'"
                                showIconIfScrollbar
                                [formControlName]="customField.id"
                                class="margin-top-6"
                                [ngClass]="{ 'is-invalid error': f[customField.id]?.errors && (f[customField.id]?.dirty || f[customField.id]?.touched) }"
                            >
                              <ng-option *ngFor="let selectedValue of customField.parsedSelectedValues"
                              class="custom-option" [value]="selectedValue">
                                {{selectedValue}}
                              </ng-option>
                            </ng-select>

                        </div>
                        <div class="form-password-toggle"
                             *ngIf="customField.fieldType === 'checkbox'"
                        >
                            <input
                                    type="checkbox"
                                    [formControlName]="customField.id"
                                    [ngClass]="{ 'is-invalid error': f[customField.id]?.errors && (f[customField.id]?.dirty || f[customField.id]?.touched) }"
                            />
                        </div>
                        <div
                                *ngIf="f[customField.id]?.errors && (f[customField.id]?.dirty || f[customField.id]?.touched)"
                                class="invalid-feedback"
                                [ngClass]="{ 'd-block': f[customField.id]?.errors && (f[customField.id]?.dirty || f[customField.id]?.touched) }"
                        >
                            <div *ngIf="f[customField.id]?.errors.required">Required</div>
                        </div>
                    </div>

                    <button class="btn btn-primary btn-block" tabindex="5" rippleEffect [disabled]="customFieldsForm.invalid">
                        <i class="fa fa-arrow-right"></i>
                        {{ 'CUSTOM_REGISTER.CONTINUE' | translate }}
                    </button>
                </form>
            </div>
        </div>
        <!-- /Register-->
    </div>
</div>
